import styled from 'styled-components'

import { helpers } from 'styles'

import { IconChevronRight } from 'components/Icons'

export const Chevron = styled(IconChevronRight)`
	color: ${helpers.color.chevron};
`
